module.exports = __webpack_public_path__ + "static/img/products application_rooftop4.0ace2d11.jpg";